import { Component, OnInit } from '@angular/core';
import {ConstantsService} from "../../fidelidade/ConstantsService";
import {BannerService} from "../../services/banner.service";
import {Router} from "@angular/router";

const UM_DIA = 24 * 60 * 60 * 1000;

@Component({
  selector: 'app-tela-cadastro-banner',
  templateUrl: './tela-cadastro-banner.component.html',
  styleUrls: ['./tela-cadastro-banner.component.scss']
})
export class TelaCadastroBannerComponent implements OnInit {
  banners = [];
  empresa: any;

  carregando = true;
  modalDeletar = false;
  removendo = false;
  bannerApagar: any;
  imagemQuebrada: any = {};

  constructor(private router: Router, private constantsService: ConstantsService, private bannerService: BannerService) { }

  ngOnInit(): void {
    this.constantsService.empresa$.subscribe( (empresa) => {
      if( !empresa ) return;

      this.empresa = empresa;

      this.bannerService.obtenhaBanners(empresa).then( (banners) => {
        this.banners = banners || [];
        this.carregando = false;
      }).catch( () => {
        this.carregando = false;
      });
    });
  }

  novo() {
    this.router.navigateByUrl('/admin/banner/novo').then( () => {
    });
  }

  editar(banner: any) {
    this.router.navigateByUrl('/admin/banner/' + banner.id).then( () => {
    });
  }

  close(status: string) {
    if( status !== 'sim') {
      this.bannerApagar = null;
      this.modalDeletar = false;
      return;
    }

    this.removendo = true;
    this.bannerService.removaBanner(this.bannerApagar).then( () => {
      this.banners = this.banners.filter( (banner) => banner !== this.bannerApagar);
      this.constantsService.recarregueEmpresa();
      this.bannerApagar = null;
      this.modalDeletar = false;
      this.removendo = false;
    }).catch( (erro) => {
      this.removendo = false;
      alert(erro);
    });
  }

  abraDialogRemover(banner: any) {
    this.bannerApagar = banner;

    this.modalDeletar = true;
  }

  // dias até a validade, contando o dia de hoje como 0; null quando não tem validade
  private diasParaVencer(banner: any): number {
    if (!banner.validade) return null;

    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    const validade = new Date(banner.validade);
    validade.setHours(0, 0, 0, 0);

    return Math.round((validade.getTime() - hoje.getTime()) / UM_DIA);
  }

  estaVencido(banner: any): boolean {
    const dias = this.diasParaVencer(banner);

    return dias !== null && dias < 0;
  }

  totalAtivos(): number {
    return this.banners.filter( (banner) => !this.estaVencido(banner)).length;
  }

  situacaoValidade(banner: any): string {
    const dias = this.diasParaVencer(banner);

    if (dias === null) return 'livre';
    if (dias < 0) return 'vencido';
    if (dias <= 7) return 'vencendo';

    return 'ok';
  }

  textoValidade(banner: any): string {
    const dias = this.diasParaVencer(banner);

    if (dias === null) return 'Sem validade';

    const data = new Date(banner.validade).toLocaleDateString('pt-BR');

    if (dias < 0) return 'Venceu em ' + data;
    if (dias === 0) return 'Vence hoje';
    if (dias === 1) return 'Vence amanhã';
    if (dias <= 7) return `Vence em ${dias} dias`;

    return 'Até ' + data;
  }

  private troquePosicoes(i: number, j: number) {
    const tmp = this.banners[i];
    this.banners[i] = this.banners[j];
    this.banners[j] = tmp;
  }

  moverCima(index: number) {
    if (index <= 0) { return; }

    const atual = this.banners[index];
    const acima = this.banners[index - 1];

    // troca na lista
    this.troquePosicoes(index, index - 1);

    // troca valores de ordem
    const ordemTemp = atual.ordem;
    atual.ordem = acima.ordem;
    acima.ordem = ordemTemp;

    this.bannerService.atualizeOrdem([atual, acima]).catch(() => {
      // reverte
      this.troquePosicoes(index - 1, index);
      const ordemTemp2 = atual.ordem;
      atual.ordem = acima.ordem;
      acima.ordem = ordemTemp2;
    });
  }

  moverBaixo(index: number) {
    if (index >= this.banners.length - 1) { return; }

    const atual = this.banners[index];
    const abaixo = this.banners[index + 1];

    // troca na lista
    this.troquePosicoes(index, index + 1);

    // troca valores de ordem
    const ordemTemp = atual.ordem;
    atual.ordem = abaixo.ordem;
    abaixo.ordem = ordemTemp;

    this.bannerService.atualizeOrdem([atual, abaixo]).catch(() => {
      // reverte
      this.troquePosicoes(index + 1, index);
      const ordemTemp2 = atual.ordem;
      atual.ordem = abaixo.ordem;
      abaixo.ordem = ordemTemp2;
    });
  }
}
